const sentryConfig = {
    CI: '//32f5201d632a4ff4a64c776db7f03523@sentry.patsnap.local/136',
    QA: '//32f5201d632a4ff4a64c776db7f03523@sentry.patsnap.local/136',
    RELEASE: '//ebd4c304f0694c429b19776667cd3380@admin-sentry.zhihuiya.com/298',
    CN: '//ebd4c304f0694c429b19776667cd3380@admin-sentry.zhihuiya.com/298',
    US: '',
    EU: '',
};
export function getSentryUrlByEnv(env) {
    const _env = env.toUpperCase();
    return sentryConfig[_env];
}
